import { render } from "./legoCarousel.vue?vue&type=template&id=1dc96310"
import script from "./legoCarousel.vue?vue&type=script&lang=js"
export * from "./legoCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoCarousel/legoCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dc96310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dc96310', __exports__)) {
    api.reload('1dc96310', __exports__)
  }
  
  module.hot.accept("./legoCarousel.vue?vue&type=template&id=1dc96310", () => {
    api.rerender('1dc96310', render)
  })

}


export default __exports__